import { ArrowLeft } from '@/assets/svgs/comps/ArrowLeft';
import Button from '@superfunnel/ui-core/v2/Button';
import React from 'react';

interface StepContentLayoutProps {
  children: React.ReactNode;
  showBackButton?: boolean;
  showNextButton?: boolean;
  nextButtonText?: string;
  nextButtonDisabled?: boolean;
  onNext?: () => void;
  onBack?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const StepContentLayout: React.FC<StepContentLayoutProps> = ({
  children,
  showBackButton = false,
  showNextButton = true,
  nextButtonText = 'Next',
  nextButtonDisabled = false,
  onNext,
  onBack,
  isLoading = false,
  disabled,
}) => {
  return (
    <div className="flex w-full flex-col gap-7">
      {children}
      <div className="flex w-full gap-3">
        {showBackButton && onBack && (
          <Button
            variant="outline"
            size="icon"
            onClick={onBack}
            disabled={disabled || isLoading}
            className="h-10 w-10"
          >
            <ArrowLeft />
          </Button>
        )}
        {showNextButton && onNext && (
          <Button
            onClick={onNext}
            disabled={nextButtonDisabled || disabled}
            loading={isLoading}
            className="flex-1"
          >
            {nextButtonText}
          </Button>
        )}
      </div>
    </div>
  );
};
